/********************************************************************
 * Copyright (c) Certus Software, 2021.                             *
 *                                                                  *
 * This unpublished material is proprietary to Certus Software.     *
 * All rights reserved. The methods and techniques described        *
 * herein are considered confidential and/or trade secrets.         *
 * Reproduction or distribution, in whole or in part, is forbidden  *
 * except by express written permission of Certus Software.         *
 ********************************************************************/

import {Component, HostListener, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {MatSidenav} from '@angular/material/sidenav';
import {environment} from '../../../../../environments/environment';
import {TranslateService} from '@ngx-translate/core';
import {CookieDetailsComponent} from '../../cookie-details/cookie-details.component';
import {AuthService} from '../../../_services/auth.service';
import {NgcCookieConsentService} from 'ngx-cookieconsent';
import {Observable, Subscription} from 'rxjs';
import {MatLegacyDialog as MatDialog} from '@angular/material/legacy-dialog';
import {UserService} from '../../../_services/user.service';

@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss']
})
export class MainLayoutComponent implements OnInit, OnDestroy {

  @ViewChild('drawer') drawer: MatSidenav;
  env = environment;
  private initializeSubscription: Subscription;
  isLoggedIn: Observable<boolean>;

  constructor(
    public router: Router,
    public translate: TranslateService,
    private authService: AuthService,
    private ccService: NgcCookieConsentService,
    public dialog: MatDialog,
    private userService: UserService
  ) {
    /* LANGUAGE CHANGE - CONFIGURE TRANSLATION HERE */
    translate.addLangs(environment.defaultLanguageOrder);
    if (this.authService.getAppLanguage() && translate.getLangs().includes(this.authService.getAppLanguage())) {
      translate.use(this.authService.getAppLanguage());
      document.documentElement.lang = this.authService.getAppLanguage();
    } else {
      this.authService.saveAppLanguage(environment.defaultLanguage);
      translate.use(environment.defaultLanguage);
      document.documentElement.lang = environment.defaultLanguage;
    }
  }

  ngOnInit(): void {
    this.isLoggedIn = this.userService.isAuthenticated;
    this.initializeSubscription = new Subscription();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    if (this.drawer.opened) {
      this.drawer.close();
    }
  }

  /* LANGUAGE CHANGE - CONFIGURE TRANSLATION HERE */

  changeAppLanguage () {
    let lang = '';
    if (this.translate.currentLang === 'hu') {
      lang = 'en';
      this.translate.use(lang);
    } else {
      lang = 'hu';
      this.translate.use(lang);
    }
    if (this.ccService.isOpen()) {
      this.changeCookiePopupLanguage();
    }
    this.authService.saveAppLanguage(lang);
    document.documentElement.lang = lang;
    this.drawer.close();
  }

  changeCookiePopupLanguage() {
    const that = this;
    this.translate
      .get(['app.cookie.message', 'app.cookie.dismiss', 'app.cookie.learnMore',
      'app.cookie.cookieConsent', 'home.resources.privacyPolicyUrl'])
      .subscribe(data => {
        this.initializeSubscription = this.ccService.popupOpen$.subscribe(
          () => {
            document.getElementsByClassName('cc-window')[0].setAttribute('aria-label', data['app.cookie.cookieConsent']);
            (document.getElementsByClassName('cc-link')[0] as HTMLElement).onclick = function () {
              return that.dialog.open(CookieDetailsComponent, {
                maxWidth: '100%',
                width: '100%'
              });
            };
          });
        this.ccService.getConfig().content = this.ccService.getConfig().content || {} ;
        // Override default messages with the translated ones
        this.ccService.getConfig().content.message = data['app.cookie.message'];
        this.ccService.getConfig().content.dismiss = data['app.cookie.dismiss'];
        this.ccService.getConfig().content.privacyPolicyLabel = data['app.cookie.learnMore'];
        // this.ccService.getConfig().content.privacyPolicyHref = data['home.resources.privacyPolicyUrl'];
        this.ccService.destroy(); // remove previous cookie bar (with default messages)
        this.ccService.init(this.ccService.getConfig()); // update config with translated messages
      });
  }

  logout() {
    this.userService.purgeAuth();
    this.router.navigate(['/login']);
  }

  changePassword() {
    this.router.navigate(['/app/change-password']);
  }

  /*preventBodyScroll() {
    if (this.drawer.opened) {
      document.querySelector('body').style.overflow = 'hidden';
    } else {
      document.querySelector('body').style.overflow = 'auto';
    }
  }*/

  ngOnDestroy() {
    this.initializeSubscription.unsubscribe();
  }
}
